import React, { useEffect, useState } from "react";
import AllNews from "../components/AllNews";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SiteMap from "../components/SiteMap";

const News = ({ legal }) => {
    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // for smoothly scrolling
        });
        
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;

    return (
        <>
            <header>
                <Header isMobile={isMobile} />
            </header>
            <main id="conteudo-principal">
                <h1 className="sr-only">Notícias</h1>
                <AllNews isMobile={isMobile} legal={legal} />
            </main>
            <footer>
                <Footer />
                <SiteMap  isMobile={isMobile}/>
            </footer>
        </>
    );
};

export default News;
